import {
  apiRegister
} from '../../common/api';
import {
  isNumber, map
} from '../../common/utils';
import {
  ERR_REQ_GAME_ID,
  ERR_REQ_TYPE
} from '../../common/const';
import {
  cleanUsers
} from './utils';
import { KUser } from '../../models/user';

/*
协议Id 
895
项目 
模块 
方式 
https 
命令（路径） 
/award/match/prerank/
说明
预赛中排行榜(晋级，买入正确，卖出正确) 只有在初赛结果时间之后才会有数据，加了时间限制
请求参数
参数名称	参数类型	说明
cId	int	比赛配置id
page	int	分页默认1
pageNum	int	每页数量默认10
type	int	类型(1晋级榜2买入榜3卖出榜)

*/

const matchPreRank = apiRegister('match-pre-rank', {
  protoId: 895,
  path: '/award/match/prerank/',
  checkQuery(Q) {
    if (!isNumber(Q.cId)) {
      return ERR_REQ_GAME_ID // 数据格式非法
    } else if (!isNumber(Q.type)) {
      return ERR_REQ_TYPE // 数据格式非法
    }
    return 0
  },
  formatResult(R) {
    const {
      total,
      userInfos
    } = R
    let {list} = R
    const userMap = cleanUsers(userInfos, true)
    list = map(list, u => {
      const user = KUser(userMap[u.uid])
      u.nick = user.nick
      u.logoSrc = user.logoSrc
      return u
    })
    return {
      total,
      list,
      userMap
    }
  }
})

export const matchPreRankLoad = matchPreRank.send

/*
协议Id 
896
项目 
模块 
方式 
https 
命令（路径） 
/award/match/finalrank/
说明
决赛排行榜
请求参数
参数名称	参数类型	说明
cId	int	比赛配置id
page	int	分页默认第一页
pageNum	每页展示数据默认10条
*/

const matchFinalRank = apiRegister('match-final-rank', {
  protoId: 896,
  path: '/award/match/finalrank/',
  checkQuery(Q) {
    if (!isNumber(Q.cId)) {
      return ERR_REQ_GAME_ID // 数据格式非法
    }
    return 0
  },
  formatResult(R) {
    const {
      total,
      userInfos
    } = R
    let {list} = R
    const userMap = cleanUsers(userInfos, true)
    list = map(list, u => {
      const user = KUser(userMap[u.uid])
      u.nick = user.nick
      u.logoSrc = user.logoSrc
      return u
    })
    return {
      total,
      list,
      userMap
    }
  }
})

export const matchFinalRankLoad = matchFinalRank.send
